import React, { useState, useEffect, useCallback, Fragment, CSSProperties } from 'react';
import { TermsOfService } from './components/TermsOfService';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { PrivilegedMemberTermsOfService } from './components/PrivilegedMemberTermsOfService';
import { PrivilegedMemberPrivacyPolicy } from './components/PrivilegedMemberPrivacyPolicy';
import { GatturiAssessmentHelp } from './components/GatturiAssessmentHelp';
import { HelpfulTools } from './components/HelpfulTools';
import { RichTextRenderer } from './components/RichTextRenderer';
import { PrivilegedMemberHelpfulTools } from './components/PrivilegedMemberHelpfulTools';
import { PrivilegedMemberRichTextRenderer } from './components/PrivilegedMemberRichTextRenderer';
import './App.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom';
import Home from './pages/Home';
import HomeWithVersion from './pages/HomeWithVersion';
import NewsPage from './pages/News';
import MansionVideoShare from './pages/MansionVideoShare';
import { VIEW_MODES } from "./Const";


function App() {
    // TODO：共有ステート化が必要
    const [viewMode, setViewMode] = useState(VIEW_MODES.AUTH);

    // TODO:ルーティング化後にどうするかは検討予定
    // ↓ ブラウザの戻るボタンの制御
    const blockBrowserBack = useCallback(() => {
        window.history.go(1)
        if (viewMode !== VIEW_MODES.AUTH) {
            setViewMode(VIEW_MODES.HOME);
        }
    }, []);
    useEffect(() => {
        // 直前の履歴に現在のページを追加
        window.history.pushState(null, '', window.location.href)
        // 直前の履歴と現在のページのループ
        window.addEventListener('popstate', blockBrowserBack)
        // クリーンアップは忘れない
        return () => {
            window.removeEventListener('popstate', blockBrowserBack)
        }
    }, [blockBrowserBack]);
    // ↑ ブラウザの戻るボタンの制御

    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/share/:apiVersion" element={<HomeWithVersion />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/privileged-member-terms-of-service" element={<PrivilegedMemberTermsOfService />} />
                <Route path="/privileged-member-privacy-policy" element={<PrivilegedMemberPrivacyPolicy />} />
                <Route path="/gatturi-assessment-help" element={<GatturiAssessmentHelp />} />
                <Route path="/news/:newsHash" element={<NewsPage />} />
                <Route path="/mansion_video_share" element={<MansionVideoShare />} />
                <Route path="/helpful-tools" element={<HelpfulTools />} />
                <Route path="/helpful-tools/:toolId" element={<RichTextRenderer />} />
                <Route path="/privileged-member-helpful-tools" element={<PrivilegedMemberHelpfulTools />} />
                <Route path="/privileged-member-helpful-tools/:toolId" element={<PrivilegedMemberRichTextRenderer />} />
                {/* どのルートにもマッチしないときも一旦はHomeを表示 */}
                <Route path="*" element={<Home />} />
            </Routes>
        </Router>
    );
}

export default App;
